module.exports = "/hub/_next/static/assets/69379ed313367c611032a28d75ac1cba.svg";